import { useEffect, useState, type ChangeEvent } from 'react';
import Switch from '@mui/material/Switch';
import { useStyles } from 'src/shared/components/IosToggleSwitch/styles';

type IOSSwitchProps = {
  disabled?: boolean;
  sourceChecked?: boolean | undefined;
  onToggleClick?: () => Promise<boolean | void> | void;
};

const IOSSwitch = ({ sourceChecked, onToggleClick, disabled }: IOSSwitchProps) => {
  const classes = useStyles();
  const [switchChecked, setSwitchhecked] = useState<boolean | undefined>(false);

  useEffect(() => {
    setSwitchhecked(sourceChecked);
  }, [sourceChecked]);

  const onChange = async (event: ChangeEvent) => {
    const { checked } = event.target as HTMLInputElement;
    if (onToggleClick !== null && onToggleClick !== undefined) {
      const maybesuccess = await onToggleClick();

      if (!maybesuccess) {
        return;
      }
    }
    setSwitchhecked(checked);
  };

  return (
    <Switch
      disabled={disabled}
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      inputProps={{ 'aria-label': 'controlled' }}
      checked={switchChecked}
      onChange={onChange}
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked
      }}
    />
  );
};

export default IOSSwitch;
